import { ReactNode, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import useStorageNps from '../store/useStorageNps'
import useStorageCsat from '../store/useStorageCsat'
import useStorageCommon from '../store/useStorageCommon'

export const DataProvider = ({ children }: { children: ReactNode }) => {
  const [searchParams, _setSearchParams] = useSearchParams()
  const setSource = useStorageCommon((state) => state.setSource)
  const setCsatToken = useStorageCsat((state) => state.setCsatToken)
  const setInitialRatingCsat = useStorageCsat(
    (state) => state.setInitialRatingCsat
  )
  const setInitialRatingNps = useStorageNps(
    (state) => state.setInitialRatingNps
  )

  useEffect(() => {
    const csatToken = searchParams.get('uuid')
    const source = searchParams.get('source') // 'app' or 'web'
    const csatRating = searchParams.get('csatRating')
    const npsRating = searchParams.get('npsRating')

    if (csatToken && csatToken !== '') {
      setCsatToken(csatToken)
    }

    setSource(source && source !== '' && source === 'app' ? 'app' : 'web')

    setInitialRatingCsat(
      csatRating && csatRating !== '' ? parseInt(csatRating) : 0
    )
    setInitialRatingNps(npsRating && npsRating !== '' ? parseInt(npsRating) : 0)
  }, [])

  return <>{children}</>
}

